// extracted by mini-css-extract-plugin
export default {"text_container":"forgot-password-page_text_container__ZNYpg","button_reset":"forgot-password-page_button_reset__G7hBo"};